import * as React from 'react';

import './LicensingInformationViewer.scss';

interface LicensingInformationViewerProps {
  text: string;
}

// refactor into modal TODO(UI-2438)
class LicensingInformationViewer extends React.Component<LicensingInformationViewerProps, {}> {
  render() {
    const { text } = this.props;

    return (
      <div className="LicensingInformationViewer">
        <div className="LicensingInformationViewer-body">
          <div className="LicensingInformationViewer-contentWrapper">
            <div className="LicensingInformationViewer-privacyPolicyText" />
            <p>{text}</p>
          </div>
        </div>
        <div className="LicensingInformationViewer-normalizeWidthWrapper" />
      </div>
    );
  }
}

export default LicensingInformationViewer;
